var _excluded = ["children", "styleType", "stylePosition", "spacing"],
  _excluded2 = ["as"],
  _excluded3 = ["as"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { Icon } from '../icon';
import { tqc, forwardRef, omitThemingProps, useMultiStyleConfig, StylesProvider, useStyles } from '../../system';
import { getValidChildren, __DEV__ } from '../../utils';
import * as React from 'react';
/**
 * List is used to display list items, it renders a `<ul>` by default.
 */
export var List = forwardRef((props, ref) => {
  var styles = useMultiStyleConfig('List', props);
  var _omitThemingProps = omitThemingProps(props),
    {
      children,
      styleType = 'none',
      stylePosition,
      spacing
    } = _omitThemingProps,
    rest = _objectWithoutProperties(_omitThemingProps, _excluded);
  var validChildren = getValidChildren(children);
  var selector = '& > *:not(style) ~ *:not(style)';
  var spacingStyle = spacing ? {
    [selector]: {
      mt: spacing
    }
  } : {};
  return /*#__PURE__*/React.createElement(StylesProvider, {
    value: styles
  }, /*#__PURE__*/React.createElement(tqc.ul, _extends({
    ref: ref,
    listStyleType: styleType,
    listStylePosition: stylePosition
    /**
     * We added this role to fix the Safari accessibility issue with list-style-type: none
     * @see https://www.scottohara.me/blog/2019/01/12/lists-and-safari.html
     */,
    role: "list",
    __css: _objectSpread(_objectSpread({}, styles.container), spacingStyle)
  }, rest), validChildren));
});
if (__DEV__) {
  List.displayName = 'List';
}
export var OrderedList = forwardRef((props, ref) => {
  var {
      as
    } = props,
    rest = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/React.createElement(List, _extends({
    ref: ref,
    as: "ol",
    styleType: "decimal",
    marginLeft: "1em"
  }, rest));
});
if (__DEV__) {
  OrderedList.displayName = 'OrderedList';
}
export var UnorderedList = forwardRef((props, ref) => {
  var {
      as
    } = props,
    rest = _objectWithoutProperties(props, _excluded3);
  return /*#__PURE__*/React.createElement(List, _extends({
    ref: ref,
    as: "ul",
    styleType: "initial",
    marginLeft: "1em"
  }, rest));
});
if (__DEV__) {
  UnorderedList.displayName = 'UnorderedList';
}
/**
 * ListItem
 *
 * Used to render a list item
 */
export var ListItem = forwardRef((props, ref) => {
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(tqc.li, _extends({
    ref: ref
  }, props, {
    __css: styles.item
  }));
});
if (__DEV__) {
  ListItem.displayName = 'ListItem';
}

/**
 * ListIcon
 *
 * Used to render an icon beside the list item text
 */
export var ListIcon = forwardRef((props, ref) => {
  var styles = useStyles();
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    role: "presentation"
  }, props, {
    __css: styles.icon
  }));
});
if (__DEV__) {
  ListIcon.displayName = 'ListIcon';
}